import React from 'react';

import './AddressAllegroSection.scss';

const AddressAllegroSection = () => (
    <section className="address-allegro-section theme-blue">
        <div className="container">
            <div className="row">
                <div className="col-12 col-md-6">
                    <h4 className="text-start">
                        <b>Print Label</b><br/>
                        Przemysław Morel<br/>
                        <b>tel.: 509 631 155</b><br/>
                        44-100 Gliwice<br/>
                        ul. Karolinki 58/112
                    </h4>
                </div>
                <div className="col-12 col-md-6 allegro-signature">
                    <a href="https://allegro.pl/uzytkownik/naturalnie_">
                        <img className="allegro-signature" alt="" src="./assets/jestesmy-allegro-link.png"/>
                    </a>
                </div>
            </div>
        </div>
    </section>
);

export default AddressAllegroSection;